/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.AccountingDataPreviewReport = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The AccountingDataPreviewReport model module.
   * @module model/AccountingDataPreviewReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>AccountingDataPreviewReport</code>.
   * @alias module:model/AccountingDataPreviewReport
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>AccountingDataPreviewReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AccountingDataPreviewReport} obj Optional instance to populate.
   * @return {module:model/AccountingDataPreviewReport} The populated <code>AccountingDataPreviewReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('AccountNumber')) {
        obj['AccountNumber'] = ApiClient.convertToType(data['AccountNumber'], 'Integer');
      }
      if (data.hasOwnProperty('Debet')) {
        obj['Debet'] = ApiClient.convertToType(data['Debet'], 'Number');
      }
      if (data.hasOwnProperty('Kredit')) {
        obj['Kredit'] = ApiClient.convertToType(data['Kredit'], 'Number');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('Dimension1')) {
        obj['Dimension1'] = ApiClient.convertToType(data['Dimension1'], 'String');
      }
      if (data.hasOwnProperty('Dimension2')) {
        obj['Dimension2'] = ApiClient.convertToType(data['Dimension2'], 'String');
      }
      if (data.hasOwnProperty('Dimension3')) {
        obj['Dimension3'] = ApiClient.convertToType(data['Dimension3'], 'String');
      }
      if (data.hasOwnProperty('Dimension4')) {
        obj['Dimension4'] = ApiClient.convertToType(data['Dimension4'], 'String');
      }
      if (data.hasOwnProperty('BookingDate')) {
        obj['BookingDate'] = ApiClient.convertToType(data['BookingDate'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} AccountNumber
   * @default 0
   */
  exports.prototype['AccountNumber'] = 0;
  /**
   * @member {Number} Debet
   * @default 0.0
   */
  exports.prototype['Debet'] = 0.0;
  /**
   * @member {Number} Kredit
   * @default 0.0
   */
  exports.prototype['Kredit'] = 0.0;
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {String} Dimension1
   * @default ''
   */
  exports.prototype['Dimension1'] = '';
  /**
   * @member {String} Dimension2
   * @default ''
   */
  exports.prototype['Dimension2'] = '';
  /**
   * @member {String} Dimension3
   * @default ''
   */
  exports.prototype['Dimension3'] = '';
  /**
   * @member {String} Dimension4
   * @default ''
   */
  exports.prototype['Dimension4'] = '';
  /**
   * @member {Date} BookingDate
   */
  exports.prototype['BookingDate'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


